export default {"id":"38101618","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}